<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div v-if="showSCHMOD==true">
                <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3557')}}</div>
                <div>
                    <div>
                        <div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3558')}}:</div>
                                </div>
                                <div v-if="schmod_locationProductionSelection.length==0 || schmod_locationProductionSelection.length>4">
                                    <select v-model="selected_schmod_locationProduction" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_locationProduction==null, my_input_background_color_at_validInput:selected_schmod_locationProduction!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="locationProduction in schmod_locationProductionSelection" v-bind:value="locationProduction">
                                            {{locationProduction.text.useTextKey?$t(locationProduction.text.textKey):locationProduction.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_locationProductionSelection.length>0 && schmod_locationProductionSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_locationProduction==null, my_input_background_color_at_validInput:selected_schmod_locationProduction!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="locationProduction in schmod_locationProductionSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_locationProduction(locationProduction)" v-bind:checked="locationProduction.selected" v-bind:disabled="locationProduction.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{locationProduction.text.useTextKey?$t(locationProduction.text.textKey):locationProduction.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3455')}}:</div>
                                </div>
                                <div v-if="schmod_certificationSelection.length==0 || schmod_certificationSelection.length>4">
                                    <select v-model="selected_schmod_Certification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_Certification==null, my_input_background_color_at_validInput:selected_schmod_Certification!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="schmod_certification in schmod_certificationSelection" v-bind:value="schmod_certification">
                                            {{schmod_certification.text.useTextKey?$t(schmod_certification.text.textKey):schmod_certification.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_certificationSelection.length>0 && schmod_certificationSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_Certification==null, my_input_background_color_at_validInput:selected_schmod_Certification!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="schmod_certification in schmod_certificationSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_certification(schmod_certification)" v-bind:checked="schmod_certification.selected" v-bind:disabled="schmod_certification.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{schmod_certification.text.useTextKey?$t(schmod_certification.text.textKey):schmod_certification.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3559')}}:</div>
                                </div>
                                <div v-if="schmod_ProdApSelection.length==0 || schmod_ProdApSelection.length>4">
                                    <select v-model="selected_schmod_ProAp" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_ProAp==null, my_input_background_color_at_validInput:selected_schmod_ProAp!=null}" v-bind:disabled="magic==true">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="proAp in schmod_ProdApSelection" v-bind:value="proAp">
                                            {{proAp.text.useTextKey?$t(proAp.text.textKey):proAp.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_ProdApSelection.length>0 && schmod_ProdApSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_ProAp==null, my_input_background_color_at_validInput:selected_schmod_ProAp!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="proAp in schmod_ProdApSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_ProAp(proAp)" v-bind:checked="proAp.selected" v-bind:disabled="proAp.selected||magic==true" />
                                                <span style="margin-left:10px">
                                                    <span>{{proAp.text.useTextKey?$t(proAp.text.textKey):proAp.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3560')}}:</div>
                                </div>
                                <div v-if="schmod_motorVoltageSelection.length==0 || schmod_motorVoltageSelection.length>4">
                                    <select v-model="selected_schmod_motorVoltage" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_motorVoltage==null, my_input_background_color_at_validInput:selected_schmod_motorVoltage!=null}" v-bind:disabled="magic==true">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorVoltage in schmod_motorVoltageSelection" v-bind:value="motorVoltage">{{motorVoltage.value}}</option>
                                    </select>
                                </div>
                                <div v-if="schmod_motorVoltageSelection.length>0 && schmod_motorVoltageSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_motorVoltage==null, my_input_background_color_at_validInput:selected_schmod_motorVoltage!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="motorVoltage in schmod_motorVoltageSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_motorVoltage(motorVoltage)" v-bind:checked="motorVoltage.selected" v-bind:disabled="motorVoltage.selected||magic==true" />
                                                <span style="margin-left:10px">{{motorVoltage.value}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3561')}}:</div>
                                </div>
                                <div>
                                    <select v-model="selected_schmod_PSGSize" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_PSGSize==null, my_input_background_color_at_validInput:selected_schmod_PSGSize!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="psgSize in schmod_PSGSizeSelection" v-bind:value="psgSize">
                                            {{psgSize.text.useTextKey?$t(psgSize.text.textKey):psgSize.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3562')}}:</div>
                                </div>
                                <div>
                                    <select v-model="selected_schmod_motorID" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_motorID==null, my_input_background_color_at_validInput:selected_schmod_motorID!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorID in schmod_motorIDSelection" v-bind:value="motorID">
                                            {{motorID.text.useTextKey?$t(motorID.text.textKey):motorID.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="magic==false||selected_schmod_motorID!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3563')}}:</div>
                                </div>
                                <div>
                                    <select v-model="selected_schmod_motorCOSName" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_motorCOSName==null, my_input_background_color_at_validInput:selected_schmod_motorCOSName!=null}" v-bind:disabled="magic==true">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorCOSName in schmod_motorCOSNameSelection" v-bind:value="motorCOSName">
                                            {{motorCOSName.text.useTextKey?$t(motorCOSName.text.textKey):motorCOSName.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="magic==false||selected_schmod_motorID!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3564')}}:</div>
                                </div>
                                <div v-if="schmod_inverterTypeSelection.length==0 || schmod_inverterTypeSelection.length>4">
                                    <select v-model="selected_schmod_inverterType" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_inverterType==null, my_input_background_color_at_validInput:selected_schmod_inverterType!=null}" v-bind:disabled="magic==true">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="inverterType in schmod_inverterTypeSelection" v-bind:value="inverterType">
                                            {{inverterType.text.useTextKey?$t(inverterType.text.textKey):inverterType.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_inverterTypeSelection.length>0 && schmod_inverterTypeSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_inverterType==null, my_input_background_color_at_validInput:selected_schmod_inverterType!=null}">
                                        <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                            <li v-for="inverterType in schmod_inverterTypeSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_inverterType(inverterType)" v-bind:checked="inverterType.selected" v-bind:disabled="inverterType.selected||magic==true" />
                                                <span style="margin-left:10px">
                                                    <span>{{inverterType.text.useTextKey?$t(inverterType.text.textKey):inverterType.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3571')}}</span>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3565')}}:</div>
                                </div>
                                <div v-if="schmod_cableLengthSelection.length==0 || schmod_cableLengthSelection.length>4">
                                    <select v-model="selected_schmod_cableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_cableLength==null, my_input_background_color_at_validInput:selected_schmod_cableLength!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="cableLength in schmod_cableLengthSelection" v-bind:value="cableLength">
                                            {{cableLength.text.useTextKey?$t(cableLength.text.textKey):cableLength.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_cableLengthSelection.length>0 && schmod_cableLengthSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_cableLength==null, my_input_background_color_at_validInput:selected_schmod_cableLength!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="cableLength in schmod_cableLengthSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_cableLength(cableLength)" v-bind:checked="cableLength.selected" v-bind:disabled="cableLength.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{cableLength.text.useTextKey?$t(cableLength.text.textKey):cableLength.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3572')}}</span>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusMotorCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Motor cable:</div>
                                </div>
                                <div v-if="schmod_orderStatusMotorCableSelection.length==0 || schmod_orderStatusMotorCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusMotorCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusMotorCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusMotorCableSelection.length>0 && schmod_orderStatusMotorCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusMotorCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusMotorCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusEncoderCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Cable Encoder:</div>
                                </div>
                                <div v-if="schmod_orderStatusEncoderCableSelection.length==0 || schmod_orderStatusEncoderCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusEncoderCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusEncoderCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusEncoderCableSelection.length>0 && schmod_orderStatusEncoderCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusEncoderCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusEncoderCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusMotorProtectionCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Cable motor temp. monitoring:</div>
                                </div>
                                <div v-if="schmod_orderStatusMotorProtectionCableSelection.length==0 || schmod_orderStatusMotorProtectionCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusMotorProtectionCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusMotorProtectionCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusMotorProtectionCableSelection.length>0 && schmod_orderStatusMotorProtectionCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusMotorProtectionCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusMotorProtectionCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3566')}}:</div>
                                </div>
                                <div v-if="schmod_cableLengthBrakeSelection.length==0 || schmod_cableLengthBrakeSelection.length>4">
                                    <select v-model="selected_schmod_cableLengthBrake" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_cableLengthBrake==null, my_input_background_color_at_validInput:selected_schmod_cableLengthBrake!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="cableLengthBrake in schmod_cableLengthBrakeSelection" v-bind:value="cableLengthBrake">
                                            {{cableLengthBrake.text.useTextKey?$t(cableLengthBrake.text.textKey):cableLengthBrake.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_cableLengthBrakeSelection.length>0 && schmod_cableLengthBrakeSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_cableLengthBrake==null, my_input_background_color_at_validInput:selected_schmod_cableLengthBrake!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="cableLengthBrake in schmod_cableLengthBrakeSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_cableLengthBrake(cableLengthBrake)" v-bind:checked="cableLengthBrake.selected" v-bind:disabled="cableLengthBrake.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{cableLengthBrake.text.useTextKey?$t(cableLengthBrake.text.textKey):cableLengthBrake.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3573')}}</span>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusBrakeCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Cable brake magnet:</div>
                                </div>
                                <div v-if="schmod_orderStatusBrakeCableSelection.length==0 || schmod_orderStatusBrakeCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusBrakeCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusBrakeCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusBrakeCableSelection.length>0 && schmod_orderStatusBrakeCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusBrakeCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusBrakeCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusBrakeMonitoringCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Cable brake monitoring:</div>
                                </div>
                                <div v-if="schmod_orderStatusBrakeMonitoringCableSelection.length==0 || schmod_orderStatusBrakeMonitoringCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusBrakeMonitoringCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusBrakeMonitoringCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusBrakeMonitoringCableSelection.length>0 && schmod_orderStatusBrakeMonitoringCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusBrakeMonitoringCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusBrakeMonitoringCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="schmod_orderStatusForcedVentilationCableSelection!=null&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div style="margin-left: 30px">
                                    <div>Cable fan:</div>
                                </div>
                                <div v-if="schmod_orderStatusForcedVentilationCableSelection.length==0 || schmod_orderStatusForcedVentilationCableSelection.length>4">
                                    <select v-model="selected_schmod_orderStatusForcedVentilationCable" class="my_select" style="width:100%">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="orderStatus in schmod_orderStatusForcedVentilationCableSelection" v-bind:value="orderStatus">
                                            {{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_orderStatusForcedVentilationCableSelection.length>0 && schmod_orderStatusForcedVentilationCableSelection.length<=4">
                                    <div style="display: grid;">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="orderStatus in schmod_orderStatusForcedVentilationCableSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_orderStatusForcedVentilationCable(orderStatus)" v-bind:checked="orderStatus.selected" v-bind:disabled="orderStatus.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{orderStatus.text.useTextKey?$t(orderStatus.text.textKey):orderStatus.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3567')}}:</div>
                                </div>
                                <div v-if="schmod_handWheelSelection.length==0 || schmod_handWheelSelection.length>4">
                                    <select v-model="selected_schmod_handWheel" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_handWheel==null, my_input_background_color_at_validInput:selected_schmod_handWheel!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="handWheel in schmod_handWheelSelection" v-bind:value="handWheel">
                                            {{handWheel.text.useTextKey?$t(handWheel.text.textKey):handWheel.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_handWheelSelection.length>0 && schmod_handWheelSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_handWheel==null, my_input_background_color_at_validInput:selected_schmod_handWheel!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="handWheel in schmod_handWheelSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_handWheel(handWheel)" v-bind:checked="handWheel.selected" v-bind:disabled="handWheel.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{handWheel.text.useTextKey?$t(handWheel.text.textKey):handWheel.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3574')}}</span>
                                </div>

                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('3568')}}:</div>
                                </div>
                                <div v-if="schmod_handReleaseSelection.length==0 || schmod_handReleaseSelection.length>4">
                                    <select v-model="selected_schmod_handRelease" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_handRelease==null, my_input_background_color_at_validInput:selected_schmod_handRelease!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="handRelease in schmod_handReleaseSelection" v-bind:value="handRelease">
                                            {{handRelease.text.useTextKey?$t(handRelease.text.textKey):handRelease.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_handReleaseSelection.length>0 && schmod_handReleaseSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_handRelease==null, my_input_background_color_at_validInput:selected_schmod_handRelease!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="handRelease in schmod_handReleaseSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_handRelease(handRelease)" v-bind:checked="handRelease.selected" v-bind:disabled="handRelease.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{handRelease.text.useTextKey?$t(handRelease.text.textKey):handRelease.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3575')}}</span>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div>{{$t('3569')}}</div>
                                </div>
                                <div>
                                    <input class="form-control" v-model="schmod_grooveDistance" v-bind:class="{my_input_border_at_invalidInput: schmod_grooveDistance_ValidationResult.invalid==true, my_input_background_color_at_validInput:schmod_grooveDistance_ValidationResult.invalid==false}" />
                                    <div>
                                        <InvalidityReasons v-if="schmod_grooveDistance_ValidationResult.invalid==true" v-bind:validationResult="schmod_grooveDistance_ValidationResult"></InvalidityReasons>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3576')}}</span>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div>{{$t('1123')}}:</div>
                                </div>
                                <div v-if="schmod_grooveSelection.length==0 || schmod_grooveSelection.length>4">
                                    <select v-model="selected_schmod_groove" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_groove==null, my_input_background_color_at_validInput:selected_schmod_groove!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="groove in schmod_grooveSelection" v-bind:value="groove">
                                            {{groove.text.useTextKey?$t(groove.text.textKey):groove.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_grooveSelection.length>0 && schmod_grooveSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selected_schmod_groove==null, my_input_background_color_at_validInput:selected_schmod_groove!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="groove in schmod_grooveSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_groove(groove)" v-bind:checked="groove.selected" v-bind:disabled="groove.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{groove.text.useTextKey?$t(groove.text.textKey):groove.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <div>{{$t('3577')}}</div>
                                    <div>{{$t('3578')}}</div>
                                </div>
                            </div>
                            <div v-if="schmod_numberOfGrooves_Disabled==false&&magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('165')}}:</div>
                                </div>
                                <div v-if="schmod_numberOfGroovesSelection.length==0 || schmod_numberOfGroovesSelection.length>4">
                                    <select v-model="selected_schmod_numberOfGrooves" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: (selected_schmod_numberOfGrooves==null && selected_schmod_ProAp != 'SCH-Magic'), my_input_background_color_at_validInput:selected_schmod_numberOfGrooves!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="numberOfGrooves in schmod_numberOfGroovesSelection" v-bind:value="numberOfGrooves">
                                            {{numberOfGrooves.text.useTextKey?$t(numberOfGrooves.text.textKey):numberOfGrooves.text.textUI}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="schmod_numberOfGroovesSelection.length>0 && schmod_numberOfGroovesSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: (selected_schmod_numberOfGrooves==null && selected_schmod_ProAp != 'SCH-Magic'), my_input_background_color_at_validInput:selected_schmod_numberOfGrooves!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="numberOfGrooves in schmod_numberOfGroovesSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_schmod_numberOfGrooves(numberOfGrooves)" v-bind:checked="numberOfGrooves.selected" v-bind:disabled="numberOfGrooves.selected" />
                                                <span style="margin-left:10px">
                                                    <span>{{numberOfGrooves.text.useTextKey?$t(numberOfGrooves.text.textKey):numberOfGrooves.text.textUI}}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3579')}}</span>
                                </div>
                            </div>
                            <div v-if="magic==false" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div>{{$t('3570')}}</div>
                                </div>
                                <div>
                                    <input class="form-control" v-model="operatingCurrentSplus" v-bind:class="{my_input_border_at_invalidInput: operatingCurrentSplus_ValidationResult.invalid==true, my_input_background_color_at_validInput:operatingCurrentSplus_ValidationResult.invalid==false}" />
                                    <div>
                                        <InvalidityReasons v-if="operatingCurrentSplus_ValidationResult.invalid==true" v-bind:validationResult="operatingCurrentSplus_ValidationResult"></InvalidityReasons>
                                    </div>
                                </div>
                                <div style="margin-left: 20px; color: #808080">
                                    <span>{{$t('3580')}}</span>
                                </div>
                            </div>
                            <div class="ZAfont_family ZAfont_size my_font-weight_600" style="margin-top: 40px; margin-bottom: 20px; color: #808080">
                                <div>{{$t('3581')}}</div>
                                <div>{{$t('3582')}}</div>
                                <div>{{$t('3583')}}</div>
                                <div>{{$t('3584')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="my_btn_nextConfigurationStep_position">
                    <button @click="furtherToManualHome()" class="btn my_btn_standard" style="margin-right: 5px">{{$t('3366')}}</button>
                    <button @click="Save_PSG518_600()" class="btn my_btn_standard" style="margin-left: 5px" v-bind:disabled="schmod_Valid==false">{{$t('1023')}}</button>
                </div>
            </div>
            <div v-if="showSCHMOD==false">
                <button @click="PSG518_600()" class="btn my_btn_standard">
                    <span v-if="customerName=='SCH-MOD'">Auswahl PSG</span>
                    <span v-if="customerName=='SCH'">Auswahl SCH-Magic</span>
                </button>
                <hr />
                <div v-if="kid!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr;padding: 5px">
                    <div class="my_font-weight_600">{{$t('3452')}}:</div>
                    <div>{{kid}}</div>
                </div>
                <hr v-if="kid!=null" />
                <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top:20px">
                    <div>
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">
                            <span style="margin-right: 5px">{{$t('1098')}}</span>
                        </div>
                        <div v-if="motorData!=null&&motorData.mTypK!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div class="ZAfont_family ZAfont_size">{{$t('3561')}}:</div>
                            <div class="ZAfont_family ZAfont_size">{{motorData.mTypK}}</div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div class="ZAfont_family ZAfont_size">{{$t('1098')}}:</div>
                            <div class="ZAfont_family ZAfont_size">
                                <span v-if="motorData!=null&&motorData.mtyP2!=null">{{motorData.mtyP2}}</span>
                                <span v-if="motorData==null||motorData.mtyP2==null">{{$t('1259')}}</span>
                            </div>
                        </div>
                        <div v-if="motorData!=null&&motorData.msart!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div class="ZAfont_family ZAfont_size">{{$t('3067')}}:</div>
                            <div class="ZAfont_family ZAfont_size">{{motorData.msart}}</div>
                        </div>
                        <div v-if="motorData!=null&&motorData.smU1!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div class="ZAfont_family ZAfont_size">{{$t('121')}}:</div>
                            <div class="ZAfont_family ZAfont_size">
                                <span v-if="motorData.smU1!=360">{{motorData.smU1}} V</span>
                                <span v-if="motorData.smU1==360">340 V</span>
                            </div>
                        </div>
                        <div v-if="motorData!=null&&motorData.mnr!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div class="ZAfont_family ZAfont_size">{{$t('1091')}}:</div>
                            <div class="ZAfont_family ZAfont_size">{{motorData.mnr}} rpm</div>
                        </div>
                        <div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3457')}}:</div>
                                </div>
                                <div v-if="motorIpSelection.length==0 || motorIpSelection.length>4">
                                    <select v-model="selectedMotorIp" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedMotorIp==null, my_input_background_color_at_validInput:selectedMotorIp!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorIp in motorIpSelection" v-bind:value="motorIp.text">{{motorIp.text}}</option>
                                    </select>
                                </div>
                                <div v-if="motorIpSelection.length>0 && motorIpSelection.length<=4" style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorIp==null, my_input_background_color_at_validInput:selectedMotorIp!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorIp in motorIpSelection" v-if="motorIp.display!=null && motorIp.display==true">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorIpSelection(motorIp)" v-bind:checked="motorIp.selected" v-bind:disabled="motorIp.selected" />
                                            <span style="margin-left:10px">{{motorIp.text}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('298')}}:</div>
                            </div>
                            <div v-if="forcedVentilationSelection.length==0 && forcedVentilationSelection.length>4">
                                <select v-model="selectedForcedVentilation" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedForcedVentilation==null, my_input_background_color_at_validInput:selectedForcedVentilation!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="forcedVentilation in forcedVentilationSelection" v-bind:value="forcedVentilation">
                                        {{forcedVentilation.text.useTextKey?$t(forcedVentilation.text.textKey):forcedVentilation.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="forcedVentilationSelection.length>0 && forcedVentilationSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedForcedVentilation==null, my_input_background_color_at_validInput:selectedForcedVentilation!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="forcedVentilation in forcedVentilationSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilation(forcedVentilation)" v-bind:checked="forcedVentilation.selected" v-bind:disabled="forcedVentilation.selected" />
                                            <span style="margin-left:10px">{{forcedVentilation.text.useTextKey?$t(forcedVentilation.text.textKey):forcedVentilation.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="selectedForcedVentilationWithBrakeRelease!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>{{$t('3553')}}</div>
                            <div>
                                <div>
                                    <span>{{selectedForcedVentilationWithBrakeRelease.useTextKey?$t(selectedForcedVentilationWithBrakeRelease.textKey):selectedForcedVentilationWithBrakeRelease.textUI}} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="divImage">
                        <img src="../../../../public/img/ProductImages/ZAtop/ZAtop-SM250-60B-side.jpg">
                    </div>
                </div>
                <hr />
                <TractionSheaveModal v-if="showTractionSheave==true"></TractionSheaveModal>
                <RopeGuardModal v-if="showRopeGuard==true"></RopeGuardModal>

                <div class="my_btn_nextConfigurationStep_position">
                    <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
                    <button @click="furtherToDriveTechnologies()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../../../router';
    import LoaderIcon from '../../loader/LoaderIcon';
    import InvalidInputs from '../../configuration/InvalidInputs'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import Images from '../../configuration/Images';
    import TractionSheaveModal from '../../configuration/manualSteps/TractionSheaveModal';
    import RopeGuardModal from '../../configuration/manualSteps/RopeGuardModal';
    import { psgModal } from '../../../store/psgModal.module';
    import { tractionSheaveManual } from '../../../store/tractionSheaveManual.module';


    export default {
        name: 'PSGModal',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            TractionSheaveModal,
            RopeGuardModal,
        },

        created() {
            this.$store.commit('inputsManual/change_psg_storeMutation', true)
            if (this.$store.state.manualHome.kid == null) {
                router.push('../manualStep/ManualHome');
            }
            this.$store.commit('psgModal/change_SCH_psgMenu_storeMutation', true)
            //this.$store.commit('psgModal/set_showSCHMOD_storeMutation', true);
            if (this.$store.state.psgModal.motorSchModData != null) {
                this.$store.dispatch('psgModal/get_detailsSchModValuesSchModData_storeAction');
            }
            else {
                if (this.$store.state.manualHome.kid == "SCH") {
                    this.Start_PSGMagic();
                }
                else {
                    this.PSG518_600();
                }
            }
        },

        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            kid: {
                get() {
                    return this.$store.state.manualHome.kid;
                },
            },
            magic: {
                get() {
                    return this.$store.state.manualHome.kid == "SCH"
                }
            },
            showTractionSheave: {
                get() {
                    if (this.showSCHMOD == false && this.$store.state.psgModal.motorDataSch != null) {
                        return true;
                    }
                    return false;
                }
            },
            showRopeGuard: {
                get() {
                    if (this.$store.state.tractionSheaveManual.sheaveProfileSelection != null && Array.isArray(this.$store.state.tractionSheaveManual.sheaveProfileSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.tractionSheaveManual.sheaveProfileSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return true
                        }
                    }
                    if (this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection != null && Array.isArray(this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1 && this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection[firstIndex_whichMeetConditions].text.code == 0) {
                            return true
                        }
                    }
                    return false
                }
            },
            showSCHMOD: {
                get() {
                    //if (this.usePSGMagic == true) {
                    //    return true;
                    //}
                    return this.$store.state.psgModal.showSCHMOD;
                }
            },
            schmod_Valid: {
                get() {
                    return this.$store.state.psgModal.schmod_Valid;
                }
            },
            customerName: {
                get() {
                    return this.$store.state.manualHome.kid;
                },
            },
            // motor
            motorData: {
                get() {
                    if (this.$store.state.psgModal.motorDataSch != null) {
                        return this.$store.state.psgModal.motorDataSch
                    }
                    return null;
                },
            },

            operatingCurrentSplus: {
                get() {
                    const localDecimal = { value: this.$store.state.psgModal.operatingCurrentSplus.value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                },
                set(value) {
                    const decimalValue = this.getLocalStringToDecimalValue(value);
                    this.$store.dispatch('psgModal/change_operatingCurrentSplus_storeAction', decimalValue);
                }
            },
            operatingCurrentSplus_ValidationResult: {
                get() {
                    return this.$store.state.psgModal.operatingCurrentSplus;
                },
            },
            forcedVentilationSelection: {
                get() {
                    return this.$store.state.inputsManual.forcedVentilationSelection;
                },
            },
            motorIpSelection: {
                get() {
                    return this.$store.state.inputsManual.motorIpSelection;
                },
            },
            selectedMotorIp: {
                get() {
                    if (this.$store.state.inputsManual.motorIpSelection != null && Array.isArray(this.$store.state.inputsManual.motorIpSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.motorIpSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.motorIpSelection[firstIndex_whichMeetConditions].text;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_motorIpSelection(value);
                }
            },
            selectedForcedVentilation: {
                get() {
                    if (this.$store.state.inputsManual.forcedVentilationSelection != null && Array.isArray(this.$store.state.inputsManual.forcedVentilationSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.forcedVentilationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.forcedVentilationSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_forcedVentilation(value);
                }
            },
            selectedForcedVentilationWithBrakeRelease: {
                get() {
                    if (this.$store.state.inputsManual.forcedVentilationSelection != null && Array.isArray(this.$store.state.inputsManual.forcedVentilationSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.forcedVentilationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.forcedVentilationSelection[firstIndex_whichMeetConditions].canBeCombinedWithBrakeRelease;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
            },

            // SCH-MOD Modul
            schmod_locationProductionSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_locationProductionSelection;
                },
            },
            schmod_ProdApSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_ProdApSelection;
                },
            },
            schmod_motorVoltageSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_motorVoltageSelection;
                },
            },
            schmod_PSGSizeSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_PSGSizeSelection;
                },
            },
            schmod_motorIDSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_motorIDSelection;

                },
            },
            schmod_motorCOSNameSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_motorCOSNameSelection;
                },
            },
            schmod_inverterTypeSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_inverterTypeSelection;
                },
            },
            schmod_cableLengthSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_cableLengthSelection;
                },
            },
            schmod_cableLengthBrakeSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_cableLengthBrakeSelection;
                },
            },
            schmod_handWheelSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_handWheelSelection;
                },
            },
            schmod_handReleaseSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_handReleaseSelection;
                },
            },
            schmod_grooveSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_grooveSelection;
                },
            },
            schmod_numberOfGroovesSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_numberOfGroovesSelection;
                },
            },
            schmod_certificationSelection: {
                get() {
                    return this.$store.state.psgModal.schmod_certificationSelection;
                },
            },
            schmod_orderStatusMotorCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusMotorCable != null && this.$store.state.psgModal.schmod_orderStatusMotorCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusMotorCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusMotorCable.selection;
                    }
                    return null;
                },
            },
            schmod_orderStatusEncoderCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusEncoderCable != null && this.$store.state.psgModal.schmod_orderStatusEncoderCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusEncoderCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusEncoderCable.selection;
                    }
                    return null;
                },
            },
            schmod_orderStatusMotorProtectionCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable != null && this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.selection;
                    }
                    return null;
                },
            },
            schmod_orderStatusBrakeCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusBrakeCable != null && this.$store.state.psgModal.schmod_orderStatusBrakeCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusBrakeCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusBrakeCable.selection;
                    }
                    return null;
                },
            },
            schmod_orderStatusBrakeMonitoringCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable != null && this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.selection;
                    }
                    return null;
                },
            },
            schmod_orderStatusForcedVentilationCableSelection: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable != null && this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.hasOwnProperty('selection') && this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.disabled == false) {
                        return this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.selection;
                    }
                    return null;
                },
            },
            selected_schmod_locationProduction: {
                get() {
                    if (this.$store.state.psgModal.schmod_locationProductionSelection != null && Array.isArray(this.$store.state.psgModal.schmod_locationProductionSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_locationProductionSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_locationProductionSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_locationProduction(value);
                }
            },
            selected_schmod_ProAp: {
                get() {
                    if (this.$store.state.psgModal.schmod_ProdApSelection != null && Array.isArray(this.$store.state.psgModal.schmod_ProdApSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_ProdApSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_ProdApSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_ProAp(value);
                }
            },
            selected_schmod_motorVoltage: {
                get() {
                    if (this.$store.state.psgModal.schmod_motorVoltageSelection != null && Array.isArray(this.$store.state.psgModal.schmod_motorVoltageSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_motorVoltageSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_motorVoltageSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_motorVoltage(value);
                }
            },
            selected_schmod_PSGSize: {
                get() {
                    if (this.$store.state.psgModal.schmod_PSGSizeSelection != null && Array.isArray(this.$store.state.psgModal.schmod_PSGSizeSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_PSGSizeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            if (this.$store.state.psgModal.schmod_PSGSizeSelection[firstIndex_whichMeetConditions].text.text != null && this.$store.state.psgModal.schmod_PSGSizeSelection[firstIndex_whichMeetConditions].text.text != "") {
                                return this.$store.state.psgModal.schmod_PSGSizeSelection[firstIndex_whichMeetConditions];
                            }
                            else {
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_PSGSize(value);
                }
            },
            selected_schmod_motorID: {
                get() {
                    if (this.$store.state.psgModal.schmod_motorIDSelection != null && Array.isArray(this.$store.state.psgModal.schmod_motorIDSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_motorIDSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            if (this.$store.state.psgModal.schmod_motorIDSelection[firstIndex_whichMeetConditions].text.text != null && this.$store.state.psgModal.schmod_motorIDSelection[firstIndex_whichMeetConditions].text.text != "") {
                                return this.$store.state.psgModal.schmod_motorIDSelection[firstIndex_whichMeetConditions];
                            }
                            else {
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_motorID(value);
                }
            },
            selected_schmod_motorCOSName: {
                get() {
                    if (this.$store.state.psgModal.schmod_motorCOSNameSelection != null && Array.isArray(this.$store.state.psgModal.schmod_motorCOSNameSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_motorCOSNameSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            if (this.$store.state.psgModal.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions].text.text != null && this.$store.state.psgModal.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions].text.text != "") {
                                return this.$store.state.psgModal.schmod_motorCOSNameSelection[firstIndex_whichMeetConditions];
                            }
                            else {
                                return null;
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_motorCOSName(value);
                }
            },
            selected_schmod_inverterType: {
                get() {
                    if (this.$store.state.psgModal.schmod_inverterTypeSelection != null && Array.isArray(this.$store.state.psgModal.schmod_inverterTypeSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_inverterTypeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_inverterTypeSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_inverterType(value);
                }
            },
            selected_schmod_cableLength: {
                get() {
                    if (this.$store.state.psgModal.schmod_cableLengthSelection != null && Array.isArray(this.$store.state.psgModal.schmod_cableLengthSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_cableLengthSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_cableLengthSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_cableLength(value);
                }
            },
            selected_schmod_cableLengthBrake: {
                get() {
                    if (this.$store.state.psgModal.schmod_cableLengthBrakeSelection != null && Array.isArray(this.$store.state.psgModal.schmod_cableLengthBrakeSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_cableLengthBrakeSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_cableLengthBrakeSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_cableLengthBrake(value);
                }
            },
            selected_schmod_handWheel: {
                get() {
                    if (this.$store.state.psgModal.schmod_handWheelSelection != null && Array.isArray(this.$store.state.psgModal.schmod_handWheelSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_handWheelSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_handWheelSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_handWheel(value);
                }
            },
            selected_schmod_handRelease: {
                get() {
                    if (this.$store.state.psgModal.schmod_handReleaseSelection != null && Array.isArray(this.$store.state.psgModal.schmod_handReleaseSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_handReleaseSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_handReleaseSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_handRelease(value);
                }
            },
            schmod_grooveDistance: {
                get() {
                    return this.$store.state.psgModal.schmod_grooveDistance.value;
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_grooveDistance(value);
                }
            },
            schmod_grooveDistance_ValidationResult: {
                get() {
                    return this.$store.state.psgModal.schmod_grooveDistance;
                },
            },
            selected_schmod_groove: {
                get() {
                    if (this.$store.state.psgModal.schmod_grooveSelection != null && Array.isArray(this.$store.state.psgModal.schmod_grooveSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_grooveSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_grooveSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_groove(value);
                }
            },
            selected_schmod_numberOfGrooves: {
                get() {
                    if (this.$store.state.psgModal.schmod_numberOfGroovesSelection != null && Array.isArray(this.$store.state.psgModal.schmod_numberOfGroovesSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_numberOfGroovesSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_numberOfGroovesSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_numberOfGrooves(value);
                }
            },
            schmod_numberOfGrooves_Disabled: {
                get() {
                    if (this.$store.state.psgModal.schmod_numberOfGroovesSelection != null && Array.isArray(this.$store.state.psgModal.schmod_numberOfGroovesSelection)) {
                        if (this.$store.state.psgModal.schmod_numberOfGroovesSelection.length == 1) {
                            if (this.$store.state.psgModal.schmod_numberOfGroovesSelection[0].text.text == null || this.$store.state.psgModal.schmod_numberOfGroovesSelection[0].text.text == '') {
                                return true;
                            }
                            return false
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                },
            },
            selected_schmod_Certification: {
                get() {
                    if (this.$store.state.psgModal.schmod_certificationSelection != null && Array.isArray(this.$store.state.psgModal.schmod_certificationSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_certificationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_certificationSelection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_certification(value);
                }
            },

            selected_schmod_orderStatusMotorCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusMotorCable != null && this.$store.state.psgModal.schmod_orderStatusMotorCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusMotorCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusMotorCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusMotorCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusMotorCable(value);
                }
            },
            selected_schmod_orderStatusEncoderCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusEncoderCable != null && this.$store.state.psgModal.schmod_orderStatusEncoderCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusEncoderCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusEncoderCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusEncoderCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusEncoderCable(value);
                }
            },
            selected_schmod_orderStatusMotorProtectionCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable != null && this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusMotorProtectionCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusMotorProtectionCable(value);
                }
            },
            selected_schmod_orderStatusBrakeCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusBrakeCable != null && this.$store.state.psgModal.schmod_orderStatusBrakeCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusBrakeCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusBrakeCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusBrakeCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusBrakeCable(value);
                }
            },
            selected_schmod_orderStatusBrakeMonitoringCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable != null && this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusBrakeMonitoringCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusBrakeMonitoringCable(value);
                }
            },
            selected_schmod_orderStatusForcedVentilationCable: {
                get() {
                    if (this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable != null && this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.hasOwnProperty('selection') && Array.isArray(this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.selection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.selection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.psgModal.schmod_orderStatusForcedVentilationCable.selection[firstIndex_whichMeetConditions];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_schmod_orderStatusForcedVentilationCable(value);
                }
            },


            statusModal_Shown: {
                get() {
                    return this.$store.state.statusHandling.statusModal_Shown;
                },
            },
            usePSGMagic: {
                get() {
                    return this.$store.state.psgModal.psgMagic;
                }
            },
            usePSGMenu: {
                get() {
                    return this.$store.state.psgModal.psgMenu;
                }
            },
        },
        methods: {
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },
            getLocalStringToDecimalValue(value) {

                const valueDecimalCriteria = this.$localDecimal;
                valueDecimalCriteria.value = value;
                if (this.$store.state.configurations.language == 'de') {
                    valueDecimalCriteria.country = 'de-DE';
                }
                else {
                    valueDecimalCriteria.country = 'en-US';
                }
                return this.$set_decimalValueToLocaleString(valueDecimalCriteria);
            },
            change_Selected_atElementOf_motorIpSelection(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorIpSelected_storeAction', value);
            },
            change_Selected_atElementOf_forcedVentilation(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_forcedVentilation_storeAction', value);
            },
            // SCH-MOD
            change_Selected_atElementOf_schmod_locationProduction(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_locationProduction_storeAction', value);
            },
            change_Selected_atElementOf_schmod_ProAp(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_ProAp_storeAction', value);
            },
            change_Selected_atElementOf_schmod_motorVoltage(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_motorVoltage_storeAction', value);
            },
            change_Selected_atElementOf_schmod_PSGSize(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_PSGSize_storeAction', value);
            },
            change_Selected_atElementOf_schmod_motorID(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_motorID_storeAction', value);
            },
            change_Selected_atElementOf_schmod_motorCOSName(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_motorCosName_storeAction', value);
            },
            change_Selected_atElementOf_schmod_inverterType(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_inverterType_storeAction', value);
            },
            change_Selected_atElementOf_schmod_cableLength(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_cableLength_storeAction', value);
            },
            change_Selected_atElementOf_schmod_cableLengthBrake(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_cableLengthBrake_storeAction', value);
            },
            change_Selected_atElementOf_schmod_handWheel(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_handWheel_storeAction', value);
            },
            change_Selected_atElementOf_schmod_handRelease(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_handRelease_storeAction', value);
            },
            change_Selected_atElementOf_schmod_grooveDistance(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_grooveDistance_storeAction', value);
            },
            change_Selected_atElementOf_schmod_groove(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_grooves_storeAction', value);
            },
            change_Selected_atElementOf_schmod_numberOfGrooves(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_numberOfGrooves_storeAction', value);
            },
            change_Selected_atElementOf_schmod_certification(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_certification_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusMotorCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusMotorCable_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusEncoderCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusEncoderCable_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusMotorProtectionCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusMotorProtectionCable_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusBrakeCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusBrakeCable_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusBrakeMonitoringCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusBrakeMonitoringCable_storeAction', value);
            },
            change_Selected_atElementOf_schmod_orderStatusForcedVentilationCable(value) {
                this.$store.dispatch('psgModal/change_SCHMOD_orderStatusForcedVentilationCable_storeAction', value);
            },
            //
            PSG518_600() {
                //this.showSCHMOD = true;
                this.$store.dispatch('psgModal/change_SCH_psgMenu_storeAction');
            },
            Start_PSG518_600() {
                this.$store.commit('psgModal/set_showSCHMOD_storeMutation', true);
                this.$store.dispatch('psgModal/get_SCHMOD_DefaultAndValuelists_storeAction');
            },
            Save_PSG518_600() {
                this.$store.dispatch('psgModal/get_detailsSchModValue_storeAction');
                //this.$store.commit('psgModal/set_showSCHMOD_storeMutation', false);
                window.scrollTo(0, 0)
            },
            Start_PSGMagic(value) {
                this.$store.dispatch('psgModal/change_SCH_magic_storeAction', value);
            },
            furtherToDriveTechnologies() {
                this.$store.dispatch('inputsManual/checkIf_inputsManualPsg_areValid_storeAction');
            },
            furtherToManualHome() {
                this.$store.dispatch('inputsManual/cancelManualMotorConfiguration_storeAction')
                this.$store.dispatch('psgModal/set_defaultValues_storeAction');
            },
        },
    }
</script>

<style>
    .divImage {
        width: 100%;
    }

        .divImage img {
            display: block;
            width: 50%;
            height: auto;
        }
</style>
